import { jsxs as w, jsx as i } from "react/jsx-runtime";
import "../../constants.js";
import { getBorderRadius as q } from "../../utils/get-border-radius.js";
import y from "clsx";
import { Slottable as f, Slot as x } from "@radix-ui/react-slot";
import { forwardRef as v } from "react";
import '../../assets/button.css';const B = "_button_gq9ct_1", N = "_button__icon_gq9ct_210", j = "_button__text_gq9ct_216", t = {
  button: B,
  "button--outline": "_button--outline_gq9ct_81",
  "button--transparent": "_button--transparent_gq9ct_82",
  "button--secondary": "_button--secondary_gq9ct_119",
  "button--tertiary": "_button--tertiary_gq9ct_143",
  "button--destructive": "_button--destructive_gq9ct_167",
  "button--size-lg": "_button--size-lg_gq9ct_191",
  "button--icon-only": "_button--icon-only_gq9ct_195",
  "button--icon-end": "_button--icon-end_gq9ct_206",
  button__icon: N,
  button__text: j,
  "button--layout-min-content": "_button--layout-min-content_gq9ct_244",
  "button--layout-full-width": "_button--layout-full-width_gq9ct_250",
  "button--expand": "_button--expand_gq9ct_260",
  "button--width-auto": "_button--width-auto_gq9ct_278",
  "button--width-full-width": "_button--width-full-width_gq9ct_282",
  "button--width-fit-content": "_button--width-fit-content_gq9ct_286",
  "button--width-sm": "_button--width-sm_gq9ct_290",
  "button--width-md": "_button--width-md_gq9ct_295",
  "button--width-lg": "_button--width-lg_gq9ct_300",
  "button--responsive": "_button--responsive_gq9ct_305"
}, z = v(
  ({
    asChild: c,
    className: r = "",
    iconOnly: l,
    rounded: b,
    iconPosition: e,
    children: s,
    variant: o,
    decoration: u,
    layout: d,
    icon: _,
    expand: a,
    style: g = {},
    responsive: m,
    width: n = "fit-content",
    ...h
  }, p) => /* @__PURE__ */ w(
    c ? x : "button",
    {
      ref: p,
      className: y(
        {
          [t.button]: !0,
          [t["button--primary"]]: o === "primary",
          [t["button--secondary"]]: o === "secondary",
          [t["button--tertiary"]]: o === "tertiary",
          [t["button--destructive"]]: o === "destructive",
          [t["button--solid"]]: u === "solid",
          [t["button--outline"]]: u === "outline",
          [t["button--transparent"]]: u === "transparent",
          [t["button--responsive"]]: m,
          [t["button--layout-full-width"]]: d === "full-width",
          [t["button--width-auto"]]: n === "auto",
          [t["button--width-full-width"]]: n === "full-width",
          [t["button--width-fit-content"]]: n === "fit-content",
          [t["button--width-sm"]]: n === "sm",
          [t["button--width-md"]]: n === "md",
          [t["button--width-lg"]]: n === "lg",
          [t["button--icon"]]: !!_,
          [t["button--icon-only"]]: l,
          [t["button--icon-start"]]: e === "start",
          [t["button--icon-end"]]: e === "end",
          [t["button--expand"]]: !!a
        },
        r
      ),
      style: {
        ...b && { "--button-rounded": q(b) },
        ...g
      },
      ...h,
      children: [
        _ && /* @__PURE__ */ i("span", { className: t.button__icon, children: _ }),
        /* @__PURE__ */ i(f, { children: s })
      ]
    }
  )
);
z.displayName = "Button";
export {
  z as Button
};
